import axios from '@/axios';

const RESOURCE_NAME = '/exports';

export default {
    exportCompanies(searchType, company_ids, columns) {
        return axios.post(`${RESOURCE_NAME}/export-companies`, {search_type: searchType, company_ids: company_ids, columns: columns})
    },

    exportCompaniesByQuery(searchType, query, params, sort, columns) {
        return axios.post(`${RESOURCE_NAME}/export-companies`, {search_type: searchType, query: query, params: params, sort: sort, columns: columns})
    },


    exportCompaniesFromTracker(trackerId, companies_ids, columns,searchType) {
        return axios.post(`${RESOURCE_NAME}/export-companies?tracker_id=${trackerId}`, {search_type: searchType, company_ids: companies_ids, columns: columns})
    },

    exportAllCompaniesFromTracker(trackerId, columns, searchType, filters) {
        return axios.post(`${RESOURCE_NAME}/export-companies?tracker_id=${trackerId}`, {search_type: searchType, columns, filters})
    },

    exportStartupsFundingsFromTracker(trackerId, startupsIds) {
        return axios.post(`${RESOURCE_NAME}/export-startups-fundings?tracker_id=${trackerId}`, {startup_ids: startupsIds})
    },

    exportAllStartupsFundingsFromTracker(trackerId, filters) {
        return axios.post(`${RESOURCE_NAME}/export-startups-fundings?tracker_id=${trackerId}`, {filters})
    },

    exportCompaniesContacts(companyType, companiesIds) {
        return axios.post(`${RESOURCE_NAME}/export-companies-contacts`, {companyType, companiesIds})
    },

    exportAllCompaniesContactsFromTracker(trackerId, filters) {
        return axios.post(`${RESOURCE_NAME}/export-companies-contacts?tracker_id=${trackerId}`, {filters})
    },

    generateStartupPdf(startupId, settings, trackerId = 0) {
        return axios.post(`${RESOURCE_NAME}/generate-startup-pdf?startup_id=${startupId}&tracker_id=${trackerId}`, {settings}, {
            responseType: 'blob',
        })
    },

    generateStartupPdfByTracker( trackerId, startupsIds, filters, settings) {
        return axios.post(`${RESOURCE_NAME}/generate-startup-pdf-by-tracker?tracker_id=${trackerId}`,
            {
                startup_ids: startupsIds,
                filters,
                settings
            }, {
                responseType: 'blob',
            }
        )
    },

    generateStartupPptByTracker( trackerId, startupsIds, filters) {
        return axios.post(`${RESOURCE_NAME}/generate-startup-ppt-by-tracker?tracker_id=${trackerId}`,
            {
                startup_ids: startupsIds,
                filters: filters
            }, {
                responseType: 'blob',
            }
        )
    },

    showStartupPdf(startupId) {
        return axios.get(`${RESOURCE_NAME}/generate-startup-pdf?startup_id=${startupId}&file=1`)
    },
}
